import { KatapultElement, html } from '../../mixins/katapult-element.js';
import { mixinBehaviors } from '@polymer/polymer/lib/legacy/class.js';
import { DefaultComputedBindings } from '../../modules/DefaultComputedBindings.js';

import '@polymer/paper-menu-button/paper-menu-button.js';
import '../input-element/input-element.js';
import { GeofireTools } from '../../modules/GeofireTools.js';
import '../paper-header/paper-header.js';
import { SquashNulls } from '../../modules/SquashNulls.js';
import { GetNewAttributeValue } from '../../modules/GetNewAttributeValue.js';
import { CamelCase } from '../../modules/CamelCase.js';
import { UnassociatePhotoFromItem } from '../../modules/UnassociatePhotoFromItem.js';
import '../style-modules/paper-menu-button-style.js';
import { Path } from '../../modules/Path.js';
import { PickAnAttribute } from '../../modules/PickAnAttribute.js';
import { AddNodeCalls } from '../../modules/AddNodeCalls.js';
import '../katapult-elements/katapult-button.js';
import { KatapultJob } from '../../modules/katapult-job/KatapultJob.js';

/** @import { PaperInputElement } from '@polymer/paper-input/paper-input.js' */

class EditAttributes extends mixinBehaviors([DefaultComputedBindings], KatapultElement) {
  static get template() {
    return html`
      <style include="paper-menu-button-style">
        [hidden] {
          display: none !important;
        }
        [invisible] {
          opacity: 0;
          pointer-events: none;
        }
        #editPanel {
          position: absolute;
          background-color: white;
          width: 100%;
          max-width: 455px;
          right: -100%;
          top: 0;
          height: 100%;
          transition: right 0.18s ease-in-out;
          z-index: 101;
          outline: none;
        }
        #editPanelScroll {
          position: relative;
          overflow-y: auto;
          height: inherit;
          display: flex;
          flex-direction: column;
        }
        #editPanel:not([opened='']) {
          /* Show the panel */
          right: 0;
        }
        #anchorEditor {
          padding: 8px;
          margin-bottom: 10px;
          border-bottom: solid medium black;
        }
        #anchorEditorHeader {
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
        }
        #closeAnchorEditDialog {
          position: absolute;
          right: 0;
        }
        #anchorEditorEditPanel {
          margin-bottom: 16px;
        }
        #anchorEditorButtons {
          display: flex;
          justify-content: space-between;
        }
        #nextButton {
          margin-left: auto;
        }
        #anchorEditorButtons katapult-button {
          background-color: #007299;
          color: white;
        }
        .anchor-editor-page {
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          gap: 8px;
        }
        .anchorEditorInputButton {
          border: 2px solid var(--paper-grey-400);
          font-weight: normal;
          height: 80px;
          min-width: 80px;
        }
        .anchorEditorInputButtonSelected {
          border: unset;
          background-color: var(--secondary-color);
          color: white;
          font-size: larger;
        }
        paper-input {
          text-align: center;
        }
        .buttons {
          flex-shrink: 0;
          margin-top: 16px;
          margin-bottom: 32px;
          display: flex;
          justify-content: space-between;
          padding-right: 16px;
          padding-left: 16px;
          box-sizing: border-box;
        }
        #okButton {
          float: right;
          min-width: 5.14em;
        }
        .itemFeedback {
          display: flex;
          border-radius: 24px;
          background-color: var(--secondary-color);
          align-items: center;
          padding: 0 12px;
          color: var(--secondary-color-text-color);
        }
        .itemFeedback > iron-icon {
          margin-right: 8px;
        }
        .itemFeedback > paper-textarea {
          --paper-input-container-color: var(--secondary-color-text-color);
          --paper-input-container-focus-color: var(--secondary-color-text-color);
          --paper-input-container-input: {
            color: var(--secondary-color-text-color);
          };
          --paper-input-container-underline: {
            opacity: 0.6;
          };
        }

        .menuButtonItemContainer {
          position: relative;
          width: 40px;
          height: 40px;
          overflow: hidden;
          cursor: pointer;
        }

        .menuButtonItemContainer iron-icon {
          height: 24px;
          width: 24px;
          padding: 8px;
        }

        .menuButtonItemContainer paper-spinner {
          height: 24px;
          width: 24px;
          padding: 8px;
        }

        #photoUploadInput {
          position: absolute;
          z-index: 12;
          top: 0;
          right: 0;
          margin: 0;
          padding: 0;
          width: 100%;
          height: 100%;
          cursor: pointer;
          opacity: 0;
          filter: alpha(opacity=0);
        }
        #dialogMenuButton {
          position: relative;
          margin-top: 0;
          margin-right: 0;
        }
        #dialogMenu {
          padding: 0;
        }
        #dialogMenu iron-icon {
          margin-right: 10px;
        }
        #dialogMenu paper-item {
          white-space: nowrap;
          padding: 0 16px !important;
          color: var(--primary-text-color);
        }
        #dialogMenu paper-item iron-icon {
          color: var(--primary-text-color-faded);
        }
        #dialogMenu paper-item:hover {
          background-color: var(--secondary-color);
          color: var(--secondary-color-text-color);
        }
        #dialogMenu paper-item:hover iron-icon {
          color: var(--secondary-color-text-color);
        }
        .title {
          font-size: 14pt;
          color: var(--primary-text-color);
          text-transform: uppercase;
        }
        .smallInfo {
          font-weight: lighter;
          font-size: 10pt;
          margin: 2px 0;
        }
        #editPanelInfo {
          background-color: #fff;
          z-index: 5;
          top: -14px;
          display: flex;
          flex-direction: column;
          flex-shrink: 0;
          padding: 8px 16px 0px 16px;
          padding-top: 8px;
          padding-bottom: 0px;
          margin-bottom: 16px;
        }
        #feebackWrapper {
          padding: 16px;
        }
        .photo {
          height: 100px;
          width: 100px;
          @apply --shadow-elevation-2dp;
          margin: 4px;
          border-radius: 8px;
          border: none;
          transition: all 0.1s;
          box-sizing: border-box;
          --katapult-photo: {
            border-radius: 6px;
          };
        }
      </style>
      <template is="dom-if" if="{{showDialog(activeTool, openEditor, editing)}}">
        <div id="editPanel" opened$="[[editing]]">
          <div id="editPanelScroll" katapult-drop-down-disable-scrolling>
            <div id="editPanelInfo">
              <div style="display: flex; align-items: center;">
                <span class="title">[[title]]</span>
                <div style="flex-grow: 1;"></div>
                <paper-menu-button
                  id="dialogMenu"
                  horizontal-align="right"
                  vertical-align="top"
                  hidden$="[[readOnlyMode(readOnlyUser, userRecord.workflows.mobile_assessment)]]"
                >
                  <katapult-button iconOnly noBorder id="dialogMenuButton" slot="dropdown-trigger" icon="more_vert"></katapult-button>
                  <div slot="dropdown-content">
                    <!-- Toggle Remove Attributes -->
                    <paper-item slot="dropdown-content" on-click="openRemoveAttribute">
                      <iron-icon icon="delete"></iron-icon>
                      <span>Remove Attribute</span>
                    </paper-item>
                    <template is="dom-if" if="{{showEditPolylineToggle(editing, activeItem)}}">
                      <paper-item slot="dropdown-content" on-click="togglePolylineEditing"
                        ><iron-icon icon="social:share"></iron-icon>Toggle Polyline Editing</paper-item
                      >
                    </template>
                    <!-- Upload Photo -->
                    <template is="dom-if" if="[[canUploadPhoto(activeItem)]]">
                      <paper-item slot="dropdown-content">
                        <iron-icon icon="image:photo-camera"></iron-icon>
                        <input id="photoUploadInput" type="file" accept="image/*" on-change="fileInputChanged" on-click="tappedFileInput" />
                        <span>Upload Photo</span>
                      </paper-item>
                    </template>
                  </div>
                </paper-menu-button>
                <katapult-button iconOnly noBorder title="Close" icon="clear" on-click="closeEditPanel"></katapult-button>
              </div>
              <!-- Coordinates -->
              <template is="dom-if" if="{{showItemCoordinates(activeItem)}}">
                <div>
                  <span class="smallInfo">([[latLngToString(selectedNodeLatitude, selectedNodeLongitude)]])</span>
                  <template is="dom-if" if="[[!readOnlyMode(readOnlyUser, userRecord.workflows.mobile_assessment)]]">
                    <katapult-button
                      iconOnly
                      noBorder
                      style="width:38px; height:38px;"
                      title="Edit"
                      icon="create"
                      on-click="toggleShowNodeLocationUpdate"
                    >
                    </katapult-button>
                  </template>
                </div>
                <template is="dom-if" if="{{showNodeLocationUpdate}}">
                  <div style="display: flex;">
                    <paper-input
                      id="latitudeInput"
                      style="box-sizing: border-box; padding-right: 5px;"
                      label="Latitude"
                      value="[[selectedNodeLatitude]]"
                      on-change="locationInputChanged"
                    >
                    </paper-input>
                    <paper-input
                      id="longitudeInput"
                      style="box-sizing: border-box; padding-left: 5px;"
                      label="Longitude"
                      value="[[selectedNodeLongitude]]"
                      on-change="locationInputChanged"
                    >
                    </paper-input>
                  </div>
                  <div style="text-align:center; margin-top:10px; margin-bottom:10px;">
                    <katapult-button style="margin-bottom:1em;" on-tap="setLocationOnMap" color="var(--secondary-color)" icon="map"
                      >Set Location on Map</katapult-button
                    >
                  </div>
                </template>
              </template>
              <template is="dom-if" if="{{showItemReferenceData(activeItem)}}">
                <span class="smallInfo" style="font-style: italic;">Reference to [[referenceJobName]]</span>
              </template>
              <!-- Anchor Edit Menu -->
              <template is="dom-if" if="{{editingAnchor(editing, activeItem, overrideEditAnchor, nodes.length)}}">
                <div id="anchorEditor">
                  <div id="anchorEditorHeader">
                    <h3>Choose [[getAnchorEntryName(anchorEntryQueue, anchorEntryQueueIndex)]]</h3>
                    <katapult-button
                      iconOnly
                      noBorder
                      id="closeAnchorEditDialog"
                      icon="close"
                      on-click="closeAnchorEditDialog"
                    ></katapult-button>
                  </div>
                  <div id="anchorEditorEditPanel">
                    <div class="anchor-editor-page" hidden$="[[!equal(anchorEntryQueueIndex, 0)]]">
                      <template is="dom-repeat" items="[[rodSizes]]">
                        <katapult-button
                          class$="[[getSelectedClass(item, anchorEntryQueueIndex, activeItem, editing, nodes.*)]]"
                          on-click="commitAnchorAttribute"
                          noRipple
                          >[[item]]</katapult-button
                        >
                      </template>
                    </div>
                    <div class="anchor-editor-page" hidden$="[[!equal(anchorEntryQueueIndex, 1)]]">
                      <template is="dom-repeat" items="[[numEyes]]">
                        <katapult-button
                          class$="[[getSelectedClass(item, anchorEntryQueueIndex, activeItem, editing, nodes.*)]]"
                          on-click="commitAnchorAttribute"
                          noRipple
                          >[[item]]</katapult-button
                        >
                      </template>
                    </div>
                    <div class="anchor-editor-page" hidden$="[[!equal(anchorEntryQueueIndex, 2)]]">
                      <template is="dom-repeat" items="[[strandSizes]]">
                        <katapult-button
                          class$="[[getSelectedClass(item, anchorEntryQueueIndex, activeItem, editing, nodes.*)]]"
                          on-click="commitAnchorAttribute"
                          noRipple
                          >[[item]]</katapult-button
                        >
                      </template>
                    </div>
                    <div class="anchor-editor-page" hidden$="[[!equal(anchorEntryQueueIndex, 3)]]">
                      <template is="dom-repeat" items="[[auxEyes]]">
                        <katapult-button
                          class$="[[getSelectedClass(item, anchorEntryQueueIndex, activeItem, editing, nodes.*)]]"
                          on-click="commitAnchorAttribute"
                          noRipple
                          >[[item]]</katapult-button
                        >
                      </template>
                    </div>
                    <div class="anchor-editor-page" hidden$="[[!equal(anchorEntryQueueIndex, 4)]]">
                      <paper-input
                        label="Enter anchor elevation"
                        type="number"
                        value="[[getAncElevation(anchorEntryQueueIndex, nodes.*)]]"
                        on-change="commitAnchorAttribute"
                      ></paper-input>
                    </div>
                  </div>
                  <div id="anchorEditorButtons">
                    <katapult-button invisible$="[[equal(anchorEntryQueueIndex, 0)]]" data-direction="prev" on-click="changeAnchorToolPage"
                      >Back</katapult-button
                    >
                    <katapult-button invisible$="[[equal(anchorEntryQueueIndex, 4)]]" data-direction="next" on-click="changeAnchorToolPage"
                      >Next</katapult-button
                    >
                  </div>
                </div>
              </template>
            </div>
            <template is="dom-if" if="[[!readOnlyMode(readOnlyUser, userRecord.workflows.mobile_assessment)]]">
              <div style="display:flex; align-items: center; padding-left: 16px; padding-right: 8px; flex-shrink: 0;">
                <katapult-drop-down
                  items="[[objectKeys(otherAttributes)]]"
                  value="{{newPropertyName}}"
                  style="flex-grow:1; margin-top:7px; margin-left:5px;"
                  label="Add Attribute"
                  mobile
                  show-last-results
                  no-label-float
                  label-function="[[camelCase]]"
                ></katapult-drop-down>
                <katapult-button iconOnly noBorder icon="add" on-click="addNewAttribute"></katapult-button>
              </div>
            </template>
            <!-- Table Attribute -->
            <paper-header-content opened="">
              <paper-cell slot="header">Attributes</paper-cell>
              <div slot="content" style="padding: 8px 16px;">
                <template
                  is="dom-repeat"
                  items="{{getItemAttributes(activeItem, quickEditItems, otherAttributes, mappingButtons, attributesChanged, connections.*, nodes.*)}}"
                >
                  <div style="[[calcTableSectionStyle(item.model.allow_scroll)]]">
                    <iron-collapse horizontal="" opened$="{{removeAttributeOpen}}">
                      <katapult-button iconOnly noBorder icon="delete" name$="{{item.name}}" on-click="removeAnAttribute"></katapult-button>
                    </iron-collapse>
                    <input-element
                      id="{{item.id}}"
                      style="[[calcTableInputStyle(item.model.allow_scroll, item.model.table_width)]]"
                      attribute_name="{{item.property}}"
                      model="{{getModel(item)}}"
                      other-attributes="[[otherAttributes]]"
                      disabled="[[readOnlyMode(readOnlyUser, userRecord.workflows.mobile_assessment)]]"
                      hide-on-disabled
                      firebase-disabled="[[disabled]]"
                      selected-picklist="[[item.selectedPicklist]]"
                      show-hidden-attributes?="{{showHiddenAttributes}}"
                      value="{{item.value}}"
                      mobile
                      on-input-element-change="commitItem"
                      user-group="[[userGroup]]"
                      name$="{{item.name}}"
                      on-search-focused="updateAnchorEditorIndex"
                      on-open-photo="openFullscreenPhoto"
                      no-label-float
                      camel-case
                      job-creator="[[jobCreator]]"
                    ></input-element>
                  </div>
                </template>
              </div>
            </paper-header-content>
            <template is="dom-if" if="[[itemPhotos.length]]">
              <paper-header-content render="{{photosRender}}" on-render-changed="renderPhotosChanged">
                <paper-cell slot="header">Photos</paper-cell>
                <template is="dom-if" if="[[photosRender]]" restamp="">
                  <div slot="content" style="padding: 8px 16px; display: flex; flex-wrap: wrap; justify-content: center;">
                    <template is="dom-repeat" items="[[itemPhotos]]" as="photoId">
                      <katapult-photo-viewer
                        class="photo"
                        load-data=""
                        disabled="[[disabled]]"
                        published=""
                        job-id="[[jobid]]"
                        photo-id="[[photoId]]"
                        size="small"
                        style="margin-right:0.5em;"
                        no-fit=""
                        on-reload-urls="reloadJobUrls"
                        on-click="openFullscreenPhoto"
                      ></katapult-photo-viewer>
                    </template>
                  </div>
                </template>
              </paper-header-content>
            </template>
            <template is="dom-if" if="{{status.published}}">
              <!--Item Feedback-->
              <div id="feebackWrapper" style="flex-shrink: 0;">
                <div class="itemFeedback">
                  <iron-icon icon="communication:message"></iron-icon>
                  <paper-textarea
                    id="element"
                    style="flex-grow:1; flex-shrink:2;"
                    value="[[getFeedbackValue(activeItem)]]"
                    label="Feedback"
                    on-blur="commitFeedback"
                    no-label-float=""
                  ></paper-textarea>
                </div>
              </div>
            </template>
            <div style="flex-grow: 1; flex-shrink: 0;"></div>
            <div class="buttons">
              <template is="dom-if" if="[[!readOnlyMode(readOnlyUser, userRecord.workflows.mobile_assessment)]]">
                <katapult-button color="#d23f31" style="min-width: 5.14em;" on-click="deleteItem">Delete</katapult-button>
              </template>
              <katapult-button id="okButton" on-click="closeEditPanel" outline="">Ok</katapult-button>
            </div>
          </div>
        </div>
      </template>
    `;
  }

  /*
      fires toast, prompt, cancel-prompt, secondary-prompt, cancel-secondary-prompt zoom-to-active
    */
  static get is() {
    return 'edit-attributes';
  }

  static get properties() {
    return {
      activeItem: {
        type: String,
        notify: true,
        observer: 'activeItemChanged'
      },
      activeCommand: {
        type: String,
        notify: true
      },
      activeButton: {
        type: String,
        notify: true
      },
      activeTool: {
        type: String,
        notify: true
      },
      activeButtonModel: {
        type: Object
      },
      anchorEntryQueue: {
        type: Array,
        value: function () {
          return [
            {
              name: 'rod size',
              attribute: 'size'
            },
            {
              name: 'number of eyes',
              attribute: 'eyes'
            },
            {
              name: 'strand sizes',
              attribute: 'sizes_of_attached_dn_guys'
            },
            {
              name: 'number of aux eyes',
              attribute: 'existing_aux_eye'
            },
            {
              name: 'anchor elevation',
              attribute: 'anc_elevation'
            }
          ];
        }
      },
      anchorEntryQueueIndex: {
        type: Number,
        value: 0
      },
      attributesChanged: {
        type: Boolean,
        value: false
      },
      auxEyes: {
        type: Array,
        value: function () {
          return ['0', '1', '2', '3'];
        }
      },
      color: {
        type: String,
        value: '#d23f31'
      },
      icon: {
        type: String,
        value: 'image:edit'
      },
      editing: {
        type: String,
        value: ''
      },
      showNodeLocationUpdate: {
        type: Boolean,
        value: false
      },
      jobid: {
        type: String
      },
      fileFolder: String,
      connections: {
        type: Object
      },
      modelDefaults: {
        type: Object,
        value: {}
      },
      newPropertyName: {
        type: String,
        value: ''
      },
      nodes: {
        type: Object
      },
      numEyes: {
        type: Array,
        value: function () {
          return ['0', '1', '2', '3', 'BUR'];
        }
      },
      otherAttributes: {
        type: Object
      },
      jobStyles: Object,
      mappingButtons: {
        type: Object
      },
      readOnlyUser: Boolean,
      userRecord: {
        type: Object
      },
      selectedNodeLatitude: Number,
      selectedNodeLongitude: Number,
      status: Object,
      strandSizes: {
        type: Array,
        computed: 'computeAttributeValues(otherAttributes, "down_guy_spec", "default")'
      },
      removeAttributeOpen: {
        type: Boolean,
        value: false
      },
      rodSizes: {
        type: Array,
        computed: 'computeAttributeValues(otherAttributes, "rod_size", "original")'
      },
      quickEditItems: {
        type: Array,
        value: []
      },
      uid: String,
      uploadParameters: {
        type: Array,
        value: function () {
          return [];
        }
      },
      uploadsInProgress: {
        type: Number,
        notify: true
      },
      uploadsComplete: {
        type: Number,
        notify: true
      },
      showUploadNotification: {
        type: Boolean,
        notify: true,
        value: false
      },
      uploadMessage: {
        type: String,
        notify: true
      },
      userGroup: String,
      disabled: Boolean,
      activeItemLookup: {
        type: Object,
        value: function () {
          return {
            n: 'Node',
            c: 'Connection',
            s: 'Section'
          };
        }
      },
      progressPercentage: {
        type: Number,
        value: 0,
        notify: true
      }
    };
  }

  constructor() {
    super();
    this.browserInfo = self.browserInfo;
    this.latLngToString = (lat, lng) => `${Number(lat).toFixed(7)}, ${Number(lng).toFixed(7)}`;
  }

  static get observers() {
    return [
      'updateNodeOrderAttribute(editing, activeItem, nodes.*, modelDefaults)',
      'updateTitle(editing, orderValue, editingJob, mainJobName, modelDefaults)',
      'updateItemPhotos(editing, activeItem, nodes.*, connections.*)'
    ];
  }

  ready() {
    super.ready();
  }

  static get importMeta() {
    return import.meta;
  }

  equal(a, b) {
    return a == b;
  }

  camelCase(attr) {
    return CamelCase(attr);
  }

  readOnlyMode(readOnlyUser, mobile_assessment) {
    return this.readOnlyUser == true || mobile_assessment == true;
  }

  init(button) {
    this.activeCommand = 'select';
    this.dispatchEvent(
      new CustomEvent('prompt', {
        detail: {
          text: `Select Item To ${this.readOnlyMode(this.readOnlyUser, this.userRecord?.workflows?.mobile_assessment) ? 'View' : 'Edit'}`
        }
      })
    );
    this.dispatchEvent(new CustomEvent('cancel-secondary-prompt'));
  }

  activeItemChanged() {
    this.overrideEditAnchor = false;
  }

  computeAttributeValues(otherAttributes, attributeName, picklistName) {
    let values = [];
    if (otherAttributes) {
      let picklist = null;
      // Check for rod_size because the "size" attribute has been used interchangeably, and we should fall back on that
      if (attributeName == 'rod_size') {
        // Try to get both the rod_size and size picklists
        const rodSizePicklists = otherAttributes?.rod_size?.picklists;
        const rodSizePicklist = rodSizePicklists?.[picklistName] || Object.values(rodSizePicklists ?? {})[0];
        const sizePicklists = otherAttributes?.size?.picklists;
        const sizePicklist = sizePicklists?.[picklistName] || Object.values(sizePicklists ?? {})[0];

        // Determine which attribute is already set on the node
        const nodeAttributes = this.nodes?.[this.activeItem?.slice(1)]?.attributes;
        if (nodeAttributes?.rod_size) picklist = rodSizePicklist;
        else if (nodeAttributes?.size) picklist = sizePicklist;

        // Use whatever picklist we found
        if (!picklist) picklist = rodSizePicklist || sizePicklist;
      } else picklist = otherAttributes?.[attributeName]?.picklists?.[picklistName];

      if (picklist) {
        // Special case for down_guy_spec because they
        // can have a separate label and value
        if (attributeName == 'down_guy_spec') values = picklist.map((x) => x.label || x.value);
        else values = picklist.map((x) => x.value);
      }
    }
    // If we didn't get any values for dgs, use the default values
    if (!values.length && attributeName == 'down_guy_spec') values = ['4M', '6.6M', '6M', '7.7M', '10M', '16M', '25M'];
    return values;
  }

  map_pan(latitude, longitude, closest) {
    if (closest == null) {
      this.activeItem = '';
      this.closeEditPanel();
    } else {
      this.activeItem = closest.item;
    }
  }

  openFullscreenPhoto(e) {
    this.dispatchEvent(new CustomEvent('open-photo', { detail: e }));
  }

  select(closestItem, latitude, longitude) {
    if (closestItem == null) {
      this.dispatchEvent(new CustomEvent('toast', { detail: 'Please select closer to an existing node.' }));
    } else {
      this.openEditor = true;
      this.activeItem = closestItem.item;
      this.editing = this.activeItemLookup[this.activeItem[0]];
    }
  }

  canUploadPhoto() {
    if (this.activeItem && (this.activeItem[0] == 'n' || this.activeItem[0] == 's')) {
      return true;
    }
    return false;
  }

  showDialog(activeTool, openEditor, editing) {
    return (activeTool == 'editAttributes' || openEditor) && editing;
  }

  toggleShowNodeLocationUpdate() {
    this.showNodeLocationUpdate = !this.showNodeLocationUpdate;
  }

  updateItemPhotos() {
    let temp = [];
    if (this.activeItem) {
      let item = null;
      if (this.editing == 'Node') {
        item = this.get(`nodes.${this.activeItem.slice(1)}`);
      } else if (this.editing == 'Section') {
        let parts = this.activeItem.split(':');
        item = this.get(`connections.${parts[0].slice(1)}.sections.${parts[1]}`);
      }
      if (item && item.photos) temp = Object.keys(item.photos);
    }
    this.itemPhotos = temp;
  }

  updateNodeOrderAttribute() {
    let orderValue = null;
    if (this.editing === 'Node' && this.activeItem) {
      orderValue =
        PickAnAttribute(SquashNulls(this.nodes, this.activeItem.slice(1), 'attributes'), this.modelDefaults.ordering_attribute) || null;
    }
    this.orderValue = orderValue;
  }

  updateTitle() {
    if (this.editing === 'Node' && this.orderValue) this.title = `${CamelCase(this.modelDefaults.ordering_attribute)} ${this.orderValue}`;
    else this.title = `${this.editing} Info`;
  }

  setLocationOnMap(e) {
    const editing = this.editing;
    this.editing = '';
    this.activeTool = 'moveItem';
    this.activeCommand = 'select';

    this.dispatchEvent(
      new CustomEvent('run-command', {
        detail: {
          callback: () => {
            // Return control to "edit attributes"
            this.editing = editing;
            this.activeTool = 'editAttributes';
          }
        }
      })
    );
  }

  locationInputChanged() {
    if (this.activeItem[0] != 'n') return;

    /** @type {PaperInputElement?} */
    const latitudeInput = this.shadowRoot?.querySelector('#latitudeInput') ?? null;
    /** @type {PaperInputElement?} */
    const longitudeInput = this.shadowRoot?.querySelector('#longitudeInput') ?? null;
    if (!latitudeInput || !longitudeInput) return;

    const latitude = Number(latitudeInput.value);
    const longitude = Number(longitudeInput.value);
    if (isNaN(latitude) || isNaN(longitude)) return;

    const nodeId = this.activeItem.slice(1);
    KatapultJob.fromId(this.jobid, { noCache: true }).setNodeLocation(nodeId, [latitude, longitude]);
  }

  tappedFileInput(e) {
    this.shadowRoot.querySelector('#dialogMenu').close();
  }

  async uploadPhotoToItem(fileList, activeItem) {
    const { Uploader } = await import('../katapult-upload-page/Uploader.js');
    return new Promise((resolve, reject) => {
      if (fileList && fileList.length > 0 && activeItem && (activeItem[0] == 'n' || activeItem[0] == 's')) {
        // Get the active item type and key
        var activeItemType = activeItem[0];
        var activeItemKey = activeItem.substring(1);
        var connectionKey = null;

        // Split up the section key to get the connection key
        if (activeItemType == 's') {
          var parts = activeItemKey.split(':');
          if (parts.length == 2) {
            connectionKey = parts[0];
            activeItemKey = parts[1];
          }

          if (connectionKey == null) {
            return;
          }
        }

        let fileCount = Array.from(fileList).filter((file) => file.type === 'image/jpeg').length;
        if (fileCount) {
          this.uploadsInProgress = this.uploadsInProgress || 0;
          this.uploadsComplete = this.uploadsComplete || 0;
          this.uploadsInProgress += fileCount;
          this.showUploadNotification = true;
          if (this.uploader == null)
            this.uploader = new Uploader(config.firebaseConfigs[config.appName], {
              useWorker: this.supportsWorkerTypeModule(),
              parallelCount: 1
            });
          this.uploader.uploadFromFiles(
            fileList,
            { jobId: this.jobid, folderId: 'mobile_upload', cameraId: 'default', uid: this.uid },
            async (details) => {
              if (details.message) {
                this.uploadMessage = details.message;
                clearTimeout(this.uploadTimeout);
                this.uploadTimeout = setTimeout(() => (this.uploadMessage = null), 3000);
              }
              if (details.status === 'failed') {
                console.warn('Photo Upload Failed', details.photo);
                resolve(details);
              } else if (details.status === 'uploading') {
                this.progressPercentage = details.progress;
              } else if (details.status === 'complete') {
                let update = {};
                if (activeItemType == 'n') {
                  update['nodes/' + activeItemKey + '/photos/' + details.photo._key] = { association: true, association_type: 'manual' };
                  update['photos/' + details.photo._key + '/associated_locations/' + activeItemKey] = 'node';
                } else {
                  update['connections/' + connectionKey + '/sections/' + activeItemKey + '/photos/' + details.photo._key] = {
                    association: true,
                    association_type: 'manual'
                  };
                  update['photos/' + details.photo._key + '/associated_locations/' + connectionKey + ':' + activeItemKey] = 'section';
                }
                update['photo_summary/' + details.photo._key + '/associated'] = true;
                await FirebaseWorker.ref(`photoheight/jobs/${details.photo._jobId}`).update(update);
                this.uploadsComplete++;
                if (this.uploadsComplete == this.uploadsInProgress) {
                  setTimeout(() => {
                    this.showUploadNotification = false;
                    this.uploadsInProgress = 0;
                    this.uploadsComplete = 0;
                    this.progressPercentage = 0;
                  }, 1000);
                } else {
                  this.progressPercentage = 0;
                }
                resolve(details);
              }
            }
          );
        }
      }
    });
  }

  fileInputChanged(e) {
    let fileInput = e.currentTarget;
    let fileList = Path.get(e, 'dataTransfer.files') || Path.get(e, 'target.files');
    if (fileList && this.activeItem && (this.activeItem[0] == 'n' || this.activeItem[0] == 's')) {
      this.uploadPhotoToItem(fileList, this.activeItem).finally(() => {
        // If we fail or succeed, clear the file input
        fileInput.value = '';
      });
    }
  }

  supportsWorkerTypeModule() {
    let supports = false;
    const tester = {
      get type() {
        supports = true;
      } // it's been called, it's supported
    };
    try {
      // We use "blob://" as url to avoid an useless network request.
      // This will either throw in Chrome
      // either fire an error event in Firefox
      // which is perfect since
      // we don't need the worker to actually start,
      // checking for the type of the script is done before trying to load it.
      const worker = new Worker('blob://', tester);
    } finally {
      // OffscreenCanvas must also be supported for us to use a worker
      return supports && !!self.OffscreenCanvas;
    }
  }

  edit(closestItem, latitude, longitude, quickEditDetails) {
    if (quickEditDetails != null && quickEditDetails.items != null && quickEditDetails.items.constructor === Array) {
      this.quickEditItems = quickEditDetails.items;
      this.quickEditCallback = quickEditDetails.callback || function () {};
      this.editing = quickEditDetails.name || 'Item';
    }
  }

  showItemCoordinates(activeItem) {
    var isNode = activeItem[0] == 'n';
    if (isNode) this.showNodeLocationUpdate = false;
    return isNode;
  }

  showItemReferenceData(activeItem) {
    let isNode = activeItem[0] == 'n';
    this.referenceJobName = 'Another Job';
    if (isNode) {
      let item = SquashNulls(this.nodes, activeItem.slice(1));
      if (item && item.reference_data && item.reference_data.job_id) {
        FirebaseWorker.ref(`photoheight/jobs/${item.reference_data.job_id}/name`)
          .once('value')
          .then((s) => {
            if (s.val()) {
              this.referenceJobName = s.val();
            }
          });
        return true;
      }
    }
    return false;
  }

  getItemAttributes(activeItem, quickEditItems, otherAttributes, mappingButtons) {
    var itemList = quickEditItems;
    if (itemList.length == 0) {
      itemList = [activeItem];
    }
    var itemAttributes = [];
    for (var i = 0; i < itemList.length; i++) {
      var attributes, modelAttributes;

      if (itemList[i][0] == 'n') {
        var node = SquashNulls(this.nodes, itemList[i].slice(1));
        if (node) {
          attributes = node.attributes;
          modelAttributes = SquashNulls(mappingButtons, node.button, 'node', 'attributes');
        }
      } else if (itemList[i][0] == 'c') {
        var conn = SquashNulls(this.connections, itemList[i].slice(1));
        if (conn) {
          attributes = conn.attributes;
          modelAttributes = SquashNulls(mappingButtons, conn.button, 'connection', 'attributes');
        }
      } else if (itemList[i][0] == 's') {
        var ids = itemList[i].slice(1).split(':');
        attributes = SquashNulls(this.connections, ids[0], 'sections', ids[1], 'multi_attributes');
      }
      for (var property in attributes) {
        var selectedPicklist = SquashNulls(modelAttributes, property, 'picklist');
        if (selectedPicklist == '') {
          selectedPicklist = null;
        }
        if (SquashNulls(otherAttributes, property, 'gui_element') == 'table') {
          itemAttributes.push({
            id: property + '.' + 'table',
            name: itemList[i],
            itemKey: 'table',
            property: property,
            model: otherAttributes[property],
            selectedPicklist: selectedPicklist,
            value: attributes[property]
          });
        } else if (SquashNulls(otherAttributes, property, 'gui_element') == 'multi_dropdown') {
          // If there are any keys that don't start with -k, rekey all of them
          if (Object.keys(attributes[property]).filter((item) => !item.startsWith('-k')).length > 0) {
            console.warn(`Re-keying ${property}: children did not follow key convention`);
            attributes[property] = this.rekeyMultiDropdown(attributes[property]);
          }
          itemAttributes.push({
            id: property + '.' + 'multi_dropdown',
            name: itemList[i],
            itemKey: 'multi_dropdown',
            property: property,
            model: otherAttributes[property],
            selectedPicklist: selectedPicklist,
            value: attributes[property]
          });
        } else {
          for (var itemKey in attributes[property]) {
            itemAttributes.push({
              id: property + '.' + itemKey,
              name: itemList[i],
              itemKey: itemKey,
              property: property,
              model: otherAttributes[property],
              selectedPicklist: selectedPicklist,
              value: attributes[property][itemKey]
            });
          }
        }
      }
    }
    itemAttributes.sort(this.attributesSort);
    return itemAttributes;
  }

  attributesSort(a, b) {
    let aPriority = (a.model && a.model.priority) || Infinity;
    let bPriority = (b.model && b.model.priority) || Infinity;
    // Sort by itemKey (firebase key) if priority is equal.
    if (aPriority == bPriority) {
      if (a.itemKey > b.itemKey) return 1;
      if (a.itemKey < b.itemKey) return -1;
    }
    return aPriority - bPriority;
  }

  rekeyMultiDropdown(object) {
    let newObject = {};
    let counter = 0;
    for (const key in object) {
      // this will essentially delete any keys that don't start with -k
      // and will correctly re-order those that do
      newObject[key] = null;
      if (key.startsWith('-k')) {
        newObject[`-k${counter.toString(10).padStart(3, '0')}`] = object[key];
        counter += 1;
      }
    }
    return newObject;
  }

  getFeedbackValue(activeItem) {
    var item = {};
    if (activeItem[0] == 'n') {
      item = SquashNulls(this.nodes, activeItem.slice(1));
    } else if (activeItem[0] == 'c') {
      item = SquashNulls(this.connections, activeItem.slice(1));
    } else if (activeItem[0] == 's') {
      var ids = activeItem.slice(1).split(':');
      item = SquashNulls(this.connections, ids[0], 'sections', ids[1]);
    }
    if (item) return item.feedback;
  }

  commitFeedback(e) {
    var feedback = e.target.value;
    var path;
    if (this.activeItem[0] == 's') {
      var ids = this.activeItem.slice(1).split(':');
      path = '/connections/' + ids[0] + '/sections/' + ids[1];
    } else {
      path = (this.activeItem[0] == 'n' ? '/nodes/' : '/connections/') + this.activeItem.slice(1);
    }
    FirebaseWorker.ref('photoheight/jobs/' + this.jobid + path + '/feedback').set(
      feedback,
      function (error) {
        if (error) {
          this.dispatchEvent(new CustomEvent('toast', { detail: error }));
        }
      }.bind(this)
    );
  }

  commitItem(e) {
    if (e.detail.attribute_name == 'sizes_of_attached_dn_guys') this.anchorEntryQueueIndex = 2;
    var attributeIds = e.currentTarget.id.split('.');
    var itemId = e.currentTarget.getAttribute('name');
    var item = this.getByKey('', itemId);
    var types = { n: 'nodes', c: 'connections', s: 'sections' };
    var type = types[itemId[0]];
    var update = {};
    var id, attributes, sectionId;
    var path = null;
    let property = attributeIds[0];
    let itemKey = attributeIds[1];
    if (['table', 'multi_dropdown'].includes(SquashNulls(this.otherAttributes, property, 'gui_element'))) {
      itemKey = '';
    }
    if (itemId[0] == 'n' || itemId[0] == 'c') {
      id = itemId.slice(1);
      // Use attributes object if it exists; if not, use an empty object
      attributes = item.attributes ? item.attributes : {};
      path = type + '/' + id + '/attributes/';
      update[path + property + '/' + itemKey] = e.detail.value;
    } else if (itemId[0] == 's') {
      var ids = itemId.slice(1).split(':');
      id = ids[0];
      sectionId = ids[1];
      attributes = item.multi_attributes;
      path = 'connections/' + id + '/sections/' + sectionId + '/multi_attributes/';
      update[path + property + '/' + itemKey] = e.detail.value;
    }
    attributes[property] = attributes[property] || {};
    if (itemKey === '') attributes[property] = e.detail.value;
    else attributes[property][itemKey] = e.detail.value;
    AddNodeCalls(property, attributes, this.otherAttributes, {
      newValue: e.detail.value,
      oldValue: e.detail.oldValue,
      update,
      updatePath: path
    });
    GeofireTools.updateStyle(type, id, item, update, this.jobStyles, sectionId);
    FirebaseWorker.ref('photoheight/jobs/' + this.jobid).update(
      update,
      function (error) {
        if (error) {
          console.log('error', error);
        }
      }.bind(this)
    );
  }

  async deleteItem(e) {
    var body = '';
    var update = {};
    let otherJobUpdate = null;
    var itemList = this.quickEditItems;
    if (itemList.length == 0) {
      itemList = [this.activeItem];
    }
    for (var i = 0; i < itemList.length; i++) {
      if (itemList[i].slice(1) != '') {
        var id = itemList[i].slice(1);
        if (itemList[i][0] == 'n') {
          let nodeData = this.getByKey('nodes', id);
          // Check if the node has reference data and if so, break the connection for both nodes
          let referenceJobId = SquashNulls(nodeData, 'reference_data', 'job_id');
          if (referenceJobId) {
            otherJobUpdate = {};
            otherJobUpdate[`${referenceJobId}/nodes/${id}/reference_data`] = null;
          }

          // Unassociate the photos from the item - mobile really should also have updateFolderCount set to true, but that might not be possible offline?
          await UnassociatePhotoFromItem(this.jobid, 'node', id, null, nodeData, update, null, this.userGroup, {
            removePhotoFromItem: false,
            updateFolderCount: false
          });

          update['nodes/' + id] = null;
          update['geohash/' + id] = null;
          var connLookup = SquashNulls(loadRenderMap.pointLocations[itemList[i].slice(1)], 'data', 'n');
          var deletedConnections = 0;
          for (var connId in connLookup) {
            await this.deleteConnection(connId, update, id);
            deletedConnections++;
          }
          if (this.quickEditItems.length == 0 && deletedConnections > 0) {
            body = '(' + deletedConnections + ') connections will be deleted.';
          }
        } else if (itemList[i][0] == 's') {
          var ids = itemList[i].slice(1).split(':');
          if (ids[0] != '' && ids[1] != '') {
            update['connections/' + ids[0] + '/sections/' + ids[1]] = null;
            update['geohash/' + ids[0] + ':' + ids[1]] = null;
            let sectionData = this.getByKey('sections', id);
            // Unassociate the photos from the item - mobile really should also have updateFolderCount set to true, but that might not be possible offline?
            await UnassociatePhotoFromItem(this.jobid, 'section', ids[1], ids[0], sectionData, update, null, this.userGroup, {
              removePhotoFromItem: false,
              updateFolderCount: false
            });
          }
        } else {
          await this.deleteConnection(id, update);
        }
      }
    }
    this.dispatchEvent(
      new CustomEvent('confirm', {
        detail: {
          heading: 'Delete this ' + this.editing + '?',
          body: body,
          affirmativeText: 'Delete',
          dismissiveText: 'Cancel',
          affirmativeStyle: 'background-color:#d23f31; color:white;',
          callback: function (update) {
            this.editing = '';
            this.activeItem = '';
            this.removeAttributeOpen = false;
            if (this.quickEditItems.length > 0) {
              this.quickEditItems = [];
              this.quickEditCallback(true);
            }
            if (this.activeTool != 'editAttributes') {
              this.openEditor = false;
            }
            FirebaseWorker.ref('photoheight/jobs/' + this.jobid).update(
              update,
              function (error) {
                if (error) {
                  this.dispatchEvent(new CustomEvent('toast', { detail: error }));
                }
              }.bind(this)
            );
            // Check if we need to update the other job
            if (otherJobUpdate) {
              FirebaseWorker.ref('photoheight/jobs').update(otherJobUpdate, (error) => {
                if (error) {
                  this.dispatchEvent(new CustomEvent('toast', { detail: error }));
                }
              });
            }
          }.bind(this, update)
        }
      })
    );
  }

  async deleteConnection(connId, update, nodeDeleting) {
    update['connections/' + connId] = null;
    update['geohash/' + connId + '~1'] = null;
    update['geohash/' + connId + '~2'] = null;

    let conn = this.connections[connId];
    if (conn.node_id_1 != nodeDeleting) {
      update['geohash/' + conn.node_id_1 + '/n/' + connId] = null;
    }
    if (conn.node_id_2 != nodeDeleting) {
      update['geohash/' + conn.node_id_2 + '/n/' + connId] = null;
    }
    for (var sectionId in conn.sections) {
      update['geohash/' + connId + ':' + sectionId] = null;
      let sectionData = this.getByKey('sections', `${connId}:${sectionId}`);
      // Unassociate the photos from the item - mobile really should also have updateFolderCount set to true, but that might not be possible offline?
      await UnassociatePhotoFromItem(this.jobid, 'section', sectionId, connId, sectionData, update, null, this.userGroup, {
        removePhotoFromItem: false,
        updateFolderCount: false
      });
    }
  }

  closeEditPanel() {
    this.editing = '';
    this.removeSelectedClass();
    this.anchorEntryQueueIndex = 0;
    this.removeAttributeOpen = false;
    if (this.quickEditItems.length > 0) {
      this.quickEditItems = [];
      this.quickEditCallback();
    }
    if (this.activeTool != 'editAttributes') {
      this.openEditor = false;
    }
  }

  addNewAttribute() {
    if (this.newPropertyName != null && this.newPropertyName != '') {
      var itemId = this.activeItem;
      if (this.quickEditItems.length > 0) {
        itemId = this.quickEditItems[this.quickEditItems.length - 1];
      }
      var item = this.getByKey('', itemId);
      var id, sectionId, attributes;
      var types = { n: 'nodes', c: 'connections', s: 'sections' };
      var type = types[itemId[0]];
      var update = {};
      // Check if the item is a section, node, or connection
      if (itemId[0] == 's') {
        var ids = itemId.slice(1).split(':');
        id = ids[0];
        sectionId = ids[1];
        attributes = this.connections[id].sections[sectionId].multi_attributes || {};
      } else {
        id = itemId.slice(1);
        attributes = item.attributes || {};
      }
      // Get the list of attributes to add if it's a group type, or just the single attribute if not
      let attributesToAdd = [this.newPropertyName];
      let groupItems = SquashNulls(this.otherAttributes, this.newPropertyName, 'group_items');
      if (SquashNulls(this.otherAttributes, this.newPropertyName, 'gui_element') === 'group' && groupItems) {
        attributesToAdd = groupItems;
      }
      attributesToAdd.forEach((newAttr) => {
        let newAttrName = typeof newAttr === 'string' ? newAttr : newAttr.attribute;
        let value = newAttr.value || GetNewAttributeValue(newAttrName, this.otherAttributes);
        var newPropertyId =
          SquashNulls(this.otherAttributes, newAttrName, 'gui_element') === 'multi_dropdown' ? '' : FirebaseWorker.ref().push().key;
        // Run the correct update depending on if the item is a section, node, or connection
        if (itemId[0] == 's') {
          update['connections/' + id + '/sections/' + sectionId + '/multi_attributes/' + newAttrName + '/' + newPropertyId] = value;
        } else {
          update[type + '/' + id + '/attributes/' + newAttrName + '/' + newPropertyId] = value;
        }
        // Add the attribute locally
        attributes[newAttrName] = attributes[newAttrName] || {};
        attributes[newAttrName][newPropertyId] = value;
      });
      GeofireTools.updateStyle(type, id, item, update, this.jobStyles, sectionId);
      FirebaseWorker.ref('photoheight/jobs/' + this.jobid).update(update);
      this.attributesChanged = !this.attributesChanged;
    }
  }

  openRemoveAttribute() {
    this.removeAttributeOpen = !this.removeAttributeOpen;
    this.shadowRoot.querySelector('#dialogMenu').close();
  }

  removeAnAttribute(e) {
    var update = {};
    var element = e.model.item;
    var keys = element.id.split('.');
    var elementName = element.name;
    var elementKey = elementName.substr(1);
    var ids = elementKey.split(':');
    var elementType = elementName.slice(0, 1);
    var types = { n: 'nodes', c: 'connections', s: 'sections' };
    var type = types[elementType];
    var id, sectionId, attributes;
    id = ids[0];
    let property = keys[0];
    let itemKey = keys[1];
    if (
      SquashNulls(this.otherAttributes, property, 'gui_element') == 'table' ||
      SquashNulls(this.otherAttributes, property, 'gui_element') == 'multi_dropdown'
    ) {
      itemKey = '';
    }
    if (elementType == 'n' || elementType == 'c') {
      update[(elementType == 'n' ? 'nodes/' : 'connections/') + ids[0] + '/attributes/' + property + '/' + itemKey] = null;
    } else {
      sectionId = ids[1];
      update['connections/' + ids[0] + '/sections/' + ids[1] + '/multi_attributes/' + property + '/' + itemKey] = null;
    }
    this.dispatchEvent(
      new CustomEvent('confirm', {
        detail: {
          heading: 'Delete this attribute?',
          body: 'The ' + property + ' attribute will be removed.',
          affirmativeText: 'Delete',
          dismissiveText: 'Cancel',
          affirmativeStyle: 'background-color:#d23f31; color:white;',
          callback: function (update) {
            var item = this.getByKey('', elementName);
            if (type == 'sections') {
              item = this.connections[id].sections[sectionId];
              attributes = item.multi_attributes;
            } else {
              attributes = item.attributes;
            }
            if (itemKey === '') delete attributes[property];
            else delete attributes[property][itemKey];
            GeofireTools.updateStyle(type, id, item, update, this.jobStyles, sectionId);
            FirebaseWorker.ref('photoheight/jobs/' + this.jobid).update(
              update,
              function (error) {
                this.attributesChanged = !this.attributesChanged;
                if (error) {
                  this.dispatchEvent(new CustomEvent('toast', { detail: error }));
                }
              }.bind(this)
            );
          }.bind(this, update)
        }
      })
    );
  }

  objectKeys(obj) {
    if (obj == null) {
      return null;
    }
    return Object.keys(obj);
  }

  showEditPolylineToggle(editing, activeItem) {
    return (
      editing == 'Connection' &&
      (SquashNulls(this.mappingButtons, SquashNulls(this.connections, activeItem.slice(1), 'button'), 'connection', 'polyline') ||
        SquashNulls(this.connections, activeItem.slice(1), 'breakpoints'))
    );
  }

  togglePolylineEditing() {
    this.fire('toggle-polyline-editing', { connId: this.activeItem.slice(1) });
    this.closeEditPanel();
  }

  getByKey(type, id, attribute) {
    return this.domHost.getByKey(type, id, attribute);
  }

  findParent(child, query, findBy, maxIterations) {
    if (typeof maxIterations == 'undefined') {
      maxIterations = 10;
    }
    if (typeof findBy == 'undefined') {
      findBy = 'tag';
    }
    var counter = 0;

    if (typeof query != 'object') query = [query];

    function foundMatch() {
      if (findBy == 'tag' && child.tagName != null) {
        for (let i = 0; i < query.length; i++) {
          if (query[i].replace(/ /g, '').toLowerCase() == child.tagName.toLowerCase()) return true;
        }
      } else if (findBy == 'class' && child.className != null) {
        var classes = child.className.split(' ');
        for (let i = 0; i < query.length; i++) {
          for (let j = 0; j < classes.length; j++) {
            if (query[i].replace(/ /g, '').toLowerCase() == classes[j].replace(/ /g, '').toLowerCase()) return true;
          }
        }
      }
      return false;
    }

    while (child != null && !foundMatch()) {
      if (counter++ == maxIterations) {
        return null;
      } else {
        child = child.parentNode;
      }
    }
    return child;
  }

  closeAnchorEditDialog() {
    this.overrideEditAnchor = true;
  }

  editingAnchor(editing, item, overrideEditAnchor) {
    if (overrideEditAnchor) return false;
    if (this.quickEditItems.length > 0 && this.quickEditItems.length < 2) {
      item = this.quickEditItems[0];
    }
    if (item != null && editing == 'Anchor') {
      return true;
    }
    return this.isAnchorNode(item);
  }

  isAnchorNode(item) {
    const validAnchorTypes = this.modelDefaults.anchor_node_types;
    const node = this.nodes?.[item.slice(1)];
    const nodeType = PickAnAttribute(node?.attributes, this.modelDefaults.node_type_attribute);
    const anchorAttributes = ['size', 'rod_size', 'eyes', 'anchor_eyes', 'sizes_of_attached_dn_guys', 'existing_aux_eye', 'anc_elevation'];
    return validAnchorTypes.includes(nodeType) && anchorAttributes.some((attr) => node.attributes[attr] != null);
  }

  getAnchorEntryName(anchorEntryQueue, anchorEntryQueueIndex) {
    return anchorEntryQueue[anchorEntryQueueIndex].name;
  }

  changeAnchorToolPage(e) {
    const direction = e.currentTarget.dataset.direction;
    let newIndex = this.anchorEntryQueueIndex + (direction == 'next' ? 1 : -1);
    if (newIndex < 0) newIndex = 0;
    if (newIndex > 4) newIndex = 4;
    this.anchorEntryQueueIndex = newIndex;
    // Scroll to the top of the edit panel
    let editPanelScroll = this.shadowRoot.querySelector('#editPanelScroll');
    if (editPanelScroll) editPanelScroll.scrollTop = 0;
  }

  getSelectedClass(item) {
    // Set the active item appropriately
    const activeItem = this.quickEditItems.length == 1 ? this.quickEditItems[0] : this.activeItem;
    const node = this.nodes?.[activeItem?.slice(1)];
    let attribute = this.anchorEntryQueue[this.anchorEntryQueueIndex].attribute;
    let value = PickAnAttribute(node?.attributes, attribute);
    // If the attribute is size, but the value is null, check for rod_size instead
    if (attribute == 'size' && value == null && this.otherAttributes.rod_size) value = PickAnAttribute(node?.attributes, 'rod_size');
    // If the attribute is eyes, but the value is null, check for anchor_eyes instead
    if (attribute == 'eyes' && value == null && this.otherAttributes.anchor_eyes) value = PickAnAttribute(node?.attributes, 'anchor_eyes');

    // Sizes of attached down guys has special logic
    if (value != null && attribute == 'sizes_of_attached_dn_guys' && value.split(',').includes(item)) {
      return 'anchorEditorInputButton anchorEditorInputButtonSelected';
    }
    if (value != null && item == value) return 'anchorEditorInputButton anchorEditorInputButtonSelected';
    return 'anchorEditorInputButton';
  }

  removeSelectedClass() {
    var buttons = this.shadowRoot.querySelectorAll('katapult-button');
    for (let i = 0; i < buttons.length; i++) {
      if (buttons[i].classList.contains('anchorEditorInputButtonSelected')) buttons[i].classList.remove('anchorEditorInputButtonSelected');
    }
  }

  commitAnchorAttribute(e) {
    // Set the active item appropriately
    const activeItem = this.quickEditItems.length == 1 ? this.quickEditItems[0] : this.activeItem;
    // Update UI
    this.removeSelectedClass();
    // If the target is a button, add the selected class. The anchor elevation input is not a button, so don't add the class because it changes the background to blue while the text remains black which is hard for the user to read
    if (!e.currentTarget.tagName == 'PAPER-INPUT') e.currentTarget.classList.add('anchorEditorInputButtonSelected');

    const nodeId = activeItem.slice(1);
    const node = this.nodes[nodeId];
    let attribute = this.anchorEntryQueue[this.anchorEntryQueueIndex].attribute;
    let update = {},
      newValue;

    // Each step has a bit of logic to apply
    const anchorEntryStep = this.anchorEntryQueue[this.anchorEntryQueueIndex].name;
    switch (anchorEntryStep) {
      case 'rod size': {
        const oldValue = PickAnAttribute(node.attributes, attribute);
        // If there is no prior value, set the attribute to be 'rod_size' instead of 'size'
        if (oldValue == null) attribute = 'rod_size';
        newValue = e.model.item;
        break;
      }
      case 'number of eyes': {
        const oldValue = PickAnAttribute(node.attributes, attribute);
        // If there is no prior value, set the attribute to be 'anchor_eyes' instead of 'eyes'
        if (oldValue == null) attribute = 'anchor_eyes';
        newValue = e.model.item;
        break;
      }
      case 'strand sizes': {
        const picklistOptions = this.otherAttributes?.down_guy_spec?.picklists?.default || [];
        let _newValue = e.model.item != null ? e.model.item.toUpperCase() : e.model.item;
        // Find the value from the picklist that matches newValue by either its label or value
        let matchingValue = picklistOptions.find((x) => {
          return x?.label?.toLowerCase() == _newValue.toLowerCase() || x?.value?.toLowerCase() == _newValue.toLowerCase();
        });
        // Set the newValue to be the matching object's value property (to make sure the data set is the value and not the label)
        if (matchingValue?.value && typeof matchingValue === 'object') _newValue = matchingValue.value;

        const oldValue = PickAnAttribute(node.attributes, attribute)?.toUpperCase?.();
        // If old value is a non-empty string, append the new value to it
        if (!!oldValue) newValue = `${oldValue.toUpperCase()},${_newValue}`;
        else newValue = _newValue;
        break;
      }
      case 'number of aux eyes': {
        newValue = e.model.item;
        break;
      }
      case 'anchor elevation': {
        newValue = e.currentTarget.value;
        break;
      }
    }

    // Build the update objects for firebase and geofire
    update[`/nodes/${nodeId}/attributes/${attribute}/button_added/`] = newValue;
    node.attributes[attribute] ??= {};
    node.attributes[attribute].button_added = newValue;
    // Run the updates
    GeofireTools.updateStyle('nodes', nodeId, node, update, this.jobStyles);
    FirebaseWorker.ref(`photoheight/jobs/${this.jobid}`).update(update, (error) => {
      if (error) this.dispatchEvent(new CustomEvent('toast', { detail: error }));
    });
  }

  getAncElevation() {
    var activeItem;
    if (this.quickEditItems.length > 0 && this.quickEditItems.length < 2) activeItem = this.quickEditItems[0];
    else activeItem = this.activeItem;
    var nodeId = activeItem.slice(1),
      node = SquashNulls(this.nodes, nodeId),
      value = node != null ? PickAnAttribute(node.attributes, 'anc_elevation') : null;
    return value;
  }

  calcTableSectionStyle(allowScroll) {
    // If allow scroll is true, the table attribute will extend offscreen and scroll horizontally
    // Otherwise, it will be squished to fit the panel
    return allowScroll ? 'display:flex; overflow-x:scroll;' : 'display:flex;';
  }

  calcTableInputStyle(allowScroll, tableWidth) {
    // This function works in tandem with calcTableSectionStyle. If allowScroll is true, the table will be the size of tableWidth
    return allowScroll ? `flex-grow: 1; flex-shrink: 2; width: ${tableWidth}px` : 'flex-grow: 1; flex-shrink: 2; max-width: 100%';
  }

  getModel(item) {
    //change model's gui_element if attribute is: sizes_of_attached_dn_guys
    if (item.property == 'sizes_of_attached_dn_guys') {
      var activeItem;
      if (this.quickEditItems.length > 0 && this.quickEditItems.length < 2) activeItem = this.quickEditItems[0];
      else activeItem = this.activeItem;
      if (this.isAnchorNode(activeItem)) {
        item.model.gui_element = 'tiles';
      }
    }
    return item.model;
  }

  updateAnchorEditorIndex(e) {
    var parent = this.findParent(e.detail.currentTarget, 'input-element', 'tag') || null;
    if (parent != null) {
      switch (parent.attribute_name) {
        case 'size':
          this.anchorEntryQueueIndex = 0;
          break;
        case 'eyes':
          this.anchorEntryQueueIndex = 1;
          break;
        case 'existing_aux_eye':
          this.anchorEntryQueueIndex = 3;
          break;
        default:
          this.anchorEntryQueueIndex = 0;
          break;
      }
    }
  }

  renderPhotosChanged(e) {
    if (e.detail.value) import('../katapult-photo/katapult-photo-viewer.js');
  }
}
customElements.define('edit-attributes', EditAttributes);
